import React from 'react';
import { useTranslation } from 'react-i18next';
import { ItemProofOfRefundModal } from '@/types/modal';
import { NoFooterModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';
import gridStyles from '../molecules/section/Grid.module.scss';
import Grid, { itemText, itemHtml } from '@/components/molecules/section/Grid';
import { transformDateString } from '@/utilities/datetime';
import { EPaymentMethod } from '@/types/item';
import { Box } from '@mui/material';

const EpaymentInfo = ({ buyerPaymentMethod, refundAccount }: { buyerPaymentMethod: string; refundAccount: string }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={gridStyles.itemInner}>
        <div>{`${buyerPaymentMethod} ${refundAccount ? `- ${refundAccount}` : ''}`}</div>
        <div className={styles.textItalic}>{t('item.refund.ePaymentNotice')}</div>
      </div>
    </>
  );
};

const ItemProofOfRefund: React.FC<{ modal: ItemProofOfRefundModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { refundData, onClose } = modal;

  const { refundList: _refundData, paymentMethod, paymentStatus } = refundData;

  const body = _refundData?.map((refund) => {
    const isEpayment = paymentMethod === EPaymentMethod.APPLE_PAY || paymentMethod === EPaymentMethod.GOOGLE_PAY;

    const items = [
      itemText(t('item.refund.amount'), refund?.amount),
      isEpayment
        ? itemHtml(
            t('item.refund.refundAccount'),
            <EpaymentInfo
              buyerPaymentMethod={paymentMethod || ''}
              refundAccount={refund.refundAccount || ''}
            />,
          )
        : itemText(t('item.refund.refundAccount'), refund?.refundAccount),
      itemText(t('item.refund.executedAt'), transformDateString(refund?.executedAt)),
    ];

    if (paymentStatus?.toLowerCase() === 'cancelled') {
      items.unshift(itemText(t('order.buyer_payment.payment_status'), paymentStatus?.toUpperCase()));
    }

    const body = (
      <div
        className={styles.itemProofOfPayment}
        key={refund.itemId}
      >
        <div className={styles.text1rem}>{`${t('common.item')} #${refund.itemId}`}</div>
        <div className={styles.text1rem}>{refund.brandName}</div>
        <div className={styles.text1rem}>{refund.productName}</div>

        <div className={styles.itemProofOfPaymentTable}>
          <Grid
            column={items?.length}
            items={items}
          />
        </div>
      </div>
    );

    return body;
  });

  return (
    <NoFooterModal
      title={t('item.refund.proofOfRefund')}
      onClose={onClose}
      body={
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
        >
          {body}
        </Box>
      }
      containerStyle={{ width: 700 }}
      modalName="item_proof_of_refund"
    />
  );
};

export default ItemProofOfRefund;
